export const VIEW_OPTIONS = {
  WEEK: 'Week',
  MONTH: 'Month',
};

export const WEEK_START_DAY = {
  SUNDAY: 'Sunday',
  MONDAY: 'Monday',
};

export enum ASSIGN_OPTIONS {
  FLEXIBLE = 'FLEXIBLE',
  DEDICATED = 'DEDICATED',
}

export enum IWorkstationAction {
  CREATE = 'CREATE',
  DELETE = 'DELETE',
}
